
import PieChart from '@/components/charts/PieExample'
import { mapGetters } from 'vuex'
export default {
  name: 'info',
  components: {PieChart},
  props: ['checklist', 'checklist_users', 'quick_reports'],
  data () {
    return {
      loading: true
    }
  },
  computed: {
    ...mapGetters({
      labels: 'Audit/getLabelQuickReport',
      data: 'Audit/getDataQuickReport',
      backgroundColor: 'Audit/getBackgroundColorQuickReport'
    })
  },
  mounted () {
    this.loading = false
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/view/info/info.js